// 孔雀蓝 Typography 组件暂无设计稿，除主题色以外，其他沿用凌莺蓝设计效果
var typographyData = {
  name: 'typography',
  data: [{
    successColor: '#38C638',
    warningColor: '#FFBC00',
    dangerColor: '#F02B2B'
  }]
};
export default typographyData;